<template>
    <form enctype="multipart/form-data" class="simple-dropzone" ref="form">
        <input
            multiple
            type="file"
            class="dropzone-input"
            @change="inputFileChanged($event)"
            @dragenter="dragging = true"
            @dragend="dragging = false"
            @dragleave="dragging = false"
        >

        <div v-if="! uploading" :class="{'dropzone-overlay': true, 'dragging' : dragging}">
            <i class="fa fa-3x fa-cloud-upload" aria-hidden="true"></i>
            <span>
                drag & drop or<br>
                click to upload
            </span>
        </div>
        <div class="dropzone-overlay" v-else>
            <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
        </div>
    </form>
</template>

<script>
export default {
    props: [
        'theme'
    ],

    data() {
        return {
            files: [],

            dragging: false,
            uploading: false,
        }
    },

    methods: {
        inputFileChanged(event) {
            this.dragging = false;
            this.files    = [...event.target.files] // hell yeah! [transform the FileList object to an array]

            this.uploadFiles();
        },

        uploadFiles() {
            this.uploading = true;

            const formData = new FormData()

            this.files.forEach(file => {
                formData.append('files[]', file, file.name)
            })

            axios.post(`/media/${this.theme}`, formData)
                .then(() => this.$emit('uploaded'))
                .catch(e => {
                    alert("Meh. Something went terribly wrong!")
                    console.error(e)
                })
                .finally(() => this.cleanUp())
        },

        cleanUp() {
            this.files = []
            this.uploading = false;

            this.$refs.form.reset()
        }
    },

    mounted() {

    }
}
</script>

<style lang="scss" scoped>

    .simple-dropzone {
        position: relative;
    }

    .dropzone-input {
        width: 100%;
        height: 100%;
        cursor: pointer;
        outline: none !important;
        box-shadow: none !important;
    }

    .dropzone-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;

        background: white;
        color: #212121;
        text-align: left;
        display: flex;
        align-items: center;
        justify-content: space-around;
        border: 2px dashed #163a86;
        color: #797979;

        &.dragging {
            border-color: #163a86;
            border-style: solid;
            color: rgba(121, 121, 121, 0.5);
        }
    }
</style>